// Public API metadata is the authority; unknown identities have no external link.
export function addressExplorerLink(base, identity) {
  return identity?.identityType === 'direct' && identity.miner && base
    ? `${base}${encodeURIComponent(identity.miner)}` : null;
}

export function isMPAccount(account, login) {
  return account?.identityType === 'mp' && account.miner === login;
}

export function supportsAuxAccount(account, login) {
  return ['direct', 'mp'].includes(account?.identityType) && account.miner === login;
}

export function minerSearchIdentity(value) {
  const identity = String(value || '').trim().replace(/^zcash:/i, '');
  return /^(?:t1|t3)[1-9A-HJ-NP-Za-km-z]{33}$/.test(identity) ? identity : '';
}
